import React, { useEffect, useState, useRef } from 'react';
import './styles.scss';
import { makeStyles } from '@material-ui/core/styles';
import { get, isEmpty } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPerformanceRecord } from '../../../actions/performanceAnalysisActions';
import PageHeading from '../../../components/PageHeading';
import PerformanceTab from './components/PerformanceTab';
import PopUpModal from '../../../components/PopUpModal';
import TestSolution from './TestSolution';
import NoData from '../../../components/NoData';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  dialogCustomizedWidth: {
    [theme.breakpoints.up('xs')]: {
      'max-width': '100%',
    },
    [theme.breakpoints.up('sm')]: {
      'max-width': '100%',
    },
    [theme.breakpoints.up('md')]: {
      'max-width': '50%',
    },
    [theme.breakpoints.up('xl')]: {
      'max-width': '35%',
    },
  },
  dialogPosition: {
    position: 'absolute',
    right: '0px',
    top: '0px',
  },
}));

export default function TestPerformanceAnalysis() {
  let absentData = [];
  let presentData = [];
  let filteredKeys = [];

  const classes = useStyles();
  const childRef = useRef();

  //State
  const [isFetching, setIsFetching] = useState(false);
  const [testID, setTestID] = useState('');
  //Redux
  const dispatch = useDispatch();

  const jwtToken = useSelector((state) =>
    get(state, 'loginReducer.data.jwt', '')
  );
  const performanceRecordData = useSelector((state) =>
    get(state, 'performanceAnalysisReducer.data', {})
  );

  const ErrorMessage = useSelector((state) =>
    get(state, 'performanceAnalysisReducer.errorMessage', '')
  );

  const handleSolution = (testId) => {
    setTestID(testId);
    childRef.current.handleClickOpen();
  };

  useEffect(() => {
    setIsFetching(true);
    fetchPerformanceRecord(jwtToken, dispatch).then(() => {
      setIsFetching(false);
    });
  }, [jwtToken]);

  if (
    !isEmpty(performanceRecordData) &&
    !isEmpty(performanceRecordData.testList)
  ) {
    absentData = performanceRecordData.testList.filter((el) => {
      return el.Status === 'A';
    });
  }

  if (
    !isEmpty(performanceRecordData) &&
    !isEmpty(performanceRecordData.testList)
  ) {
    presentData = performanceRecordData.testList.filter((el) => {
      return el.Status === 'P';
    });
  }

  const allowed = [
    'English',
    'Eng',
    'Sst',
    'sst',
    'MAT',
    'Bot',
    'Zoo',
    'Bio',
    'Math',
    'Chem',
    'Phy',
  ];
  if (
    !isEmpty(performanceRecordData) &&
    !isEmpty(performanceRecordData.testList)
  ) {
    filteredKeys = Object.keys(performanceRecordData.testList[0])
      .filter((key) => allowed.includes(key))
      .reduce((obj, key) => {
        obj[key] = performanceRecordData.testList[0][key];
        return obj;
      }, {});
  }
  const header = <div>Exam Solution </div>;
  const body = testID && <TestSolution testID={testID} />;

  return (
    <React.Fragment>
      <PageHeading titlePrimary="Test Performance" titleSecondary="Analysis" />
      {isFetching ? (
        <React.Fragment>
          <div className="flex-row">
            <Skeleton width={'15%'} height={'50px'} className="mr-10" />
            <Skeleton width={'15%'} height={'50px'} />
          </div>
          <Skeleton width={'100%'} height={'50px'} />
          <Skeleton width={'100%'} height={'50px'} />
          <Skeleton width={'100%'} height={'50px'} />
          <Skeleton width={'100%'} height={'50px'} />
          <Skeleton width={'100%'} height={'50px'} />
          <Skeleton width={'100%'} height={'50px'} />
          <Skeleton width={'100%'} height={'50px'} />
        </React.Fragment>
      ) : !isEmpty(performanceRecordData) &&
        !isEmpty(performanceRecordData.testList) ? (
        <React.Fragment>
          <PerformanceTab
            filteredKeys={filteredKeys}
            absentData={absentData}
            presentData={presentData}
            handleSolution={(val) => handleSolution(val)}
            isFetching={isFetching}
          />
          <PopUpModal
            ref={childRef}
            header={header}
            body={body}
            width={classes.dialogCustomizedWidth}
            position={classes.dialogPosition}
            fullScreen={true}
          />
        </React.Fragment>
      ) : (
        <NoData
          message={
            !isEmpty(ErrorMessage)
              ? ErrorMessage
              : 'As of Now, No data is available for you in Test Performance Analysis. Please come back later.'
          }
        />
      )}
    </React.Fragment>
  );
}
